import { render, staticRenderFns } from "./AuthResetPasswordSendEmail.vue?vue&type=template&id=e6c52596&scoped=true&"
import script from "./AuthResetPasswordSendEmail.vue?vue&type=script&lang=js&"
export * from "./AuthResetPasswordSendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c52596",
  null
  
)

export default component.exports